import { writePreferenceCookie } from "./preferences.ts";

/**
 * A hint to the server that this browser is signed in — nothing more.
 *
 * The session is a bearer token in localStorage, which the server never
 * sees by design, so the document it builds for `/` cannot know whether
 * to draw the door or the diary: it drew the door, and for a person who
 * was signed in the three sign-in buttons stood on screen until the
 * JavaScript arrived, hydrated and left for the diary — a second or more
 * on a phone, every time the app was opened from its icon. The phone
 * opens on the diary.
 *
 * So the browser leaves a note: a cookie with no secret in it, set when
 * a session begins and cleared when it ends, that only says "someone is
 * in". The server reads it to choose the door's first paint — the shell's
 * "Opening your Selfeed…" rather than the buttons — and nothing else: who
 * is in, and whether they still are, stays the token's to say, in the
 * browser, as before. A note left behind by a session that ended some
 * other way costs one neutral paint before the door.
 */
export const SESSION_HINT_COOKIE = "sf-in";

export function hasSessionHint(cookieHeader: string | null | undefined): boolean {
  return /(?:^|;\s*)sf-in=1(?:;|$)/.test(cookieHeader ?? "");
}

export function rememberSessionHint(): void {
  writePreferenceCookie(SESSION_HINT_COOKIE, "1");
}

export function forgetSessionHint(): void {
  writePreferenceCookie(SESSION_HINT_COOKIE, "", 0);
}
